import { createFeatureSelector } from "@ngrx/store";
import { IStoreState } from "./store.state";

export const dashboardStoreKey = 'dashboardStoreKey';

export const storeSelector = createFeatureSelector<IStoreState>(dashboardStoreKey);
